import { cn } from "@/lib/cn";
import { haQuantoTempo, type AtendimentoEmCurso } from "@/lib/em-atendimento";

/**
 * "Em atendimento" — o mesmo selo na lista de profissionais da Agenda e nos cartões da Equipe.
 * O ponto pulsante é o que faz a informação ler como "agora" sem precisar de texto extra.
 */
export function SeloEmAtendimento({
  atendimento,
  compacto = false,
  className,
}: {
  atendimento: AtendimentoEmCurso;
  /** Só o ponto + "Em atendimento", sem paciente nem tempo — pra caber em linha estreita. */
  compacto?: boolean;
  className?: string;
}) {
  const tempo = haQuantoTempo(atendimento.startedAt);

  return (
    <span
      title={`Em atendimento: ${atendimento.patientName}${tempo ? ` · ${tempo}` : ""}`}
      className={cn(
        "inline-flex shrink-0 items-center gap-1 rounded-full bg-cyan-50 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-cyan-700 dark:bg-cyan-500/10 dark:text-cyan-300",
        className,
      )}
    >
      <span className="relative flex h-1.5 w-1.5 shrink-0">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-cyan-500 opacity-60 motion-reduce:animate-none" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-cyan-600" />
      </span>
      {compacto ? "Atendendo" : "Em atendimento"}
      {!compacto && tempo && (
        <span className="font-medium normal-case tracking-normal opacity-70">· {tempo}</span>
      )}
    </span>
  );
}
